import { useEffect } from 'react'

import { store } from '../stores'
import { syncOrderInitiated, syncOrderRequested } from '../actions/order'
import { makeGetUnsyncedLocalIds } from '../selectors/order'
import useInterval from './useInterval'

import { networkConnected } from '../utils/networkConnected'

const FOUR_MINUTES = 240000

async function replayOrders() {
  try { await networkConnected() } catch { return }

  const getUnsyncedLocalIds = makeGetUnsyncedLocalIds()
  const unsyncedLocalIds = getUnsyncedLocalIds(store.getState(), 10)

  unsyncedLocalIds.forEach((id) => {
    store.dispatch(syncOrderInitiated(id))
    store.dispatch(syncOrderRequested(id))
  })
}

const usePollOrders = () => {
  useEffect(() => { replayOrders() }, [])
  useInterval(replayOrders, FOUR_MINUTES)
}

export default usePollOrders
